import React from 'react';
import { useLocation } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { BottomNav } from '../components/BottomNav';

interface LayoutProps {
  children: React.ReactNode;
}

/**
 * Main layout component for the application
 * Provides consistent structure across all pages
 * Conditionally renders Footer and BottomNav based on current route
 * 
 * @param children - Page content to render within the layout
 */
export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';

  return (
    <div className="bg-background min-h-screen pb-16 md:pb-0 flex flex-col">
      <div className="flex-1">{children}</div>
      {!isLoginPage && <Footer />}
      {!isLoginPage && <BottomNav />}
    </div>
  );
};
